import React from 'react';
import './quote.scss';
import lama from '../../assets/lama.jpg';
import quoteMark from '../../assets/quotemark.svg';

function Quote() {
  return (
    <div className="quote">
      <img className="quote__mark quote__mark-l" src={quoteMark} alt="" />
      <div className="quote-contents">
        <div className="quote__photo">
          <img src={lama} alt="Portrait of Lama Nachman" />
        </div>
        <div className="quote__text">
          <img className="quote__mark quote__mark-s" src={quoteMark} alt="" />
          <blockquote>
            “When I think about the common thread for all these stories, I think we all see the
            power of AI, to be a transformative <span className="linebreak">power for good.”</span>
          </blockquote>
          <div className="quote__author">
            <span className="bold">Lama Nachman,</span> Intel Fellow, Director of Human & AI Systems
            <span className="linebreak">Research Lab</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Quote;
